/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useRef } from 'react';
import AddressBadging from '../addressBadging/AddressBadging';

const Address = ({
  handleValueChange,
  handleFieldErrorChanged,
  isRequired,
  updateFieldErrors,
  fieldId,
  answer,
  library,
  handleMarker,
  locationFieldId,
  disabled
}) => {
  let autoCompleteRef = useRef(null);

  const loadScript = (url, callback) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';

    if (script.readyState) {
      script.onreadystatechange = () => {
        if (
          script.readyState === 'loaded'
          || script.readyState === 'complete'
        ) {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = () => callback();
    }

    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  };

  const handleAnswerChanged = (value, id) => {
    handleValueChange(value, id);
    let updatedErrors = [];

    if (value === '' || value === undefined) {
      handleFieldErrorChanged(id, isRequired);
      updatedErrors = [...updatedErrors, 'pulpoforms.errors.not_blank'];
    } else {
      handleFieldErrorChanged(id, false);
    }
    updateFieldErrors(updatedErrors);
  };

  async function handlePlaceSelect() {
    const addressObject = autoCompleteRef.getPlace();
    const address = addressObject.formatted_address;
    if (handleMarker && addressObject.geometry) {
      const geometry = addressObject.geometry.location;
      handleAnswerChanged(
        [geometry.lat(), geometry.lng()],
        locationFieldId || 'location'
      );
      handleMarker([geometry.lat(), geometry.lng()]);
    }
    if (address) handleAnswerChanged(address, fieldId);
  }

  const handleScriptLoad = (autoCompleteParam) => {
    autoCompleteRef = new window.google.maps.places.Autocomplete(
      autoCompleteParam.current
    );
    autoCompleteRef.setFields([
      'address_components',
      'formatted_address',
      'geometry'
    ]);
    autoCompleteRef.addListener('place_changed', () => handlePlaceSelect());
  };

  useEffect(() => {
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=${
        process.env.REACT_APP_GMAPS_KEY
      }&libraries=${library || 'places'}`,
      () => handleScriptLoad(autoCompleteRef)
    );
    if (isRequired && (answer === '' || answer === undefined)) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [answer]);

  return (
    <input
      ref={autoCompleteRef}
      onChange={event => handleAnswerChanged(event.target.value, fieldId)}
      placeholder=""
      value={answer}
      disabled={disabled}
    />
  );
};

export default props => (props.Badging ? <AddressBadging {...props} /> : <Address {...props} />);
